import React, { useContext } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import { UserContext } from "../../context/auth";
import Headline from "../Headline";
import "./style.css";

import DisplayError from "../../DisplayError";
import EmbedIframe from "./EmbedIframe";

const customerInstanceWrap = () => {
  return (
    <div className="embed--dashboard wrapper">
      <div className="row embed--customer__instance wrapper">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 customer__instance--wrap">
          <p className="customer__instance--text">
            In addition to the curated reports provided in the portal,
            additional data is available for exploration and customization at:
            <Link to={`//${"analytics.placeexchange.com/"}`} target="_blank">
              <span> analytics.placeexchange.com</span>
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

const EmbedDashboard = (props) => {
  const { data, loading, errorMessage, isViewEnabled } =
    useContext(UserContext);

  return (
    <>
      <Headline>Reporting</Headline>
      {isViewEnabled && customerInstanceWrap()}
      {!isEmpty(data) && !data.orgData.errors && !loading ? (
        <div className="embed--dashboard wrapper">
          <EmbedIframe {...props} />
        </div>
      ) : (
        <DisplayError {...errorMessage} />
      )}
    </>
  );
};

export default EmbedDashboard;
